module.exports = __webpack_public_path__ + "media/images/front/about/header_pc-13134e46611fadfaaf28931affef1039.png";